import React from 'react';
import cn from '@utils/cn';

import { TestimonialStatType } from '@lib/sanity/queries/modules/testimonialsStats/types';
import Stats from './Stats';

type TestimonialProps = {
  data?: TestimonialStatType;
  count: number;
  index: number;
  setCurrentIndex(index: number): void;
  itemContent: React.ReactNode;
};

export default function Testimonial({ itemContent, data, count, index, setCurrentIndex }: TestimonialProps) {
  if (!data) {
    return;
  }

  const circles = Array.from({ length: count }).map((_: unknown, i: number) => (
    <div
      key={i}
      className={cn('bg-tertiary h-3 w-3  rounded-full md:h-4 md:w-4', {
        'bg-tertiary-foreground': i === index,
        'cursor-pointer': i !== index,
      })}
      onClick={() => i !== index && setCurrentIndex(i)}
    />
  ));

  return (
    <>
      {itemContent}
      {count > 1 && <div className="flex justify-center gap-2 pt-8">{circles}</div>}
      {data.stats?.length && <div className="border-foreground w-full border-b pt-10 opacity-10" />}
      <Stats data={data} />
    </>
  );
}
